import { Substitute, Rule0, Rule1 } from "../../../../src/components/Substitution";
import * as React from 'react';
export default {
  Substitute,
  Rule0,
  Rule1,
  React
};